import React from 'react'
import '@loyal_template/placeholder.css'
const SidebarPlaceholder = () => (
  <div className={`container-sidebar col-12 col-md-4 col-lg-3 pb-5 px-1 px-md-2 mb-5 `}>
    <div
      className={`container-filter row radius border-color-ui-3 radius mb-2`}
    >
      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='col-5 py-half bg-ui-4 radius' />
      </div>
      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='col-5 py-half bg-ui-4 radius' />
      </div>
      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='col-3 py-half bg-ui-4 radius' />
      </div>
      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='col-5 py-half bg-ui-4 radius' />
      </div>

      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='col-3 py-half bg-ui-4 radius' />
      </div>
      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='col-5 py-half bg-ui-4 radius' />
      </div>

      <div className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='row mx-0 mb-1'>
          <div className='col-auto'>
            <div className='row'>
              <div className='pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1' />
            </div>
          </div>
          <div className='col'>
            <div className='row'>
              <div className='col-5 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
        <div className='col-3 py-half bg-ui-4 radius' />
      </div>
    </div>
  </div>
)

export default SidebarPlaceholder



// WEBPACK FOOTER //
// ./src/Catalog/Search/SidebarPlaceholder.js